import { AppBar, TitlePortal } from 'react-admin';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { ReactElement } from 'react';

export const CustomAppBar = (): ReactElement => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <AppBar>
      <TitlePortal />
      {!isSmall && (
        <Box flex="1" />
      )}
      <Box>
        <Typography variant="body2" color="inherit" sx={{ mr: 2 }}>
          Markets Admin v1.0
        </Typography>
      </Box>
    </AppBar>
  );
};
